import PeriprocedureelBeleidTARDaptAsaPraCloTic from "../../../../src/client/lta-antistolling/periprocedureel-beleid-tar-dapt-asa-pra-clo-tic.json";
import * as React from 'react';
export default {
  PeriprocedureelBeleidTARDaptAsaPraCloTic,
  React
};